import React, { useEffect, useState } from "react";
import Button from "../../component/ui/Button";
import { ageGroup, EVENT_GENDERS } from "../../helper/constant";
import Input from "../../component/ui/Input";
import Textarea from "../../component/ui/Textarea";
import RadioButton from "../../component/ui/RadioButton";
import { PhoneNumber } from "../../component/ui/PhoneNumber";
import "react-datepicker/dist/react-datepicker.css";
import SelectField from "../../component/ui/SelectField";
import UserNameHeader from "../../component/UserNameHeader";
import LocationPicker from "../../component/ui/LocationPicker";
import DateAndTimePicker from "component/ui/Datepicker";
import moment from "moment";
import {
  convertDateTimeUtc,
  isValidNumber,
  stringToBoolean,
} from "helper/appConstant";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { createEvent, getEventDetails, updateEvent } from "store/slice/booking";
import { useNavigate, useParams } from "react-router-dom";
import FullPageLoader from "component/ui/fullPageLoader";
import { MdOutlineArrowBackIosNew } from "react-icons/md";

const CreateEventCard = () => {
  const [formData, setFormData] = useState({ postTo: [] });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { configData } = useSelector((state) => state.auth);
  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const [loader, setLoader] = useState(false);
  const { eventDetailsData } = useSelector((state) => state.booking);
  useEffect(() => {
    if (id && id != "new") {
      setLoader(true);
      dispatch(getEventDetails(id, setLoader));
    } else {
      setFormData({ postTo: [] });
    }
  }, [id]);
  //  set event details data to state
  useEffect(() => {
    if (eventDetailsData && id) {
      setFormData({
        ...eventDetailsData,
        startDate: moment(eventDetailsData?.startDate, "DD/MM/YYYY").format(
          "YYYY-MM-DD",
        ),
        coordinates: eventDetailsData?.location?.coordinates,
        address: eventDetailsData?.location?.address,
      });
    }
  }, [eventDetailsData]);
  const validateEventFields = () => {
    const requiredFields = [
      { key: "ageGroup", label: "Age group" },
      { key: "gender", label: "Gender" },
      { key: "category", label: "Game / Sport" },
      { key: "postTo", label: "Post To" },
      { key: "startDate", label: "Start date" },
      { key: "startTime", label: "Start time" },
      { key: "capacity", label: "Capacity" },
      { key: "address", label: "Location" },
      { key: "eventFees", label: "Event fee" },
      { key: "phone", label: "Contact number" },
    ];

    for (let field of requiredFields) {
      const value = formData?.[field.key];

      // empty / blank check
      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && !value.trim())
      ) {
        toast.error(`${field.label} is required`);
        return false;
      }
      if (field?.key === "phone" && !isValidNumber(value?.slice(3))) {
        toast.error("Please enter a valid phone number");
        return;
      }
      // post To
      if (field.key == "postTo" && value?.length == 0) {
        toast.error("Please select post to");
        return false;
      }
      // capacity validation
      if (field.key === "capacity" && value <= 0) {
        toast.error("Capacity must be greater than 0");
        return false;
      }

      // fee validation
      if (field.key === "eventFees" && value < 0) {
        toast.error("Event fee must be valid");
        return false;
      }
    }

    // Post To validation (array)
    if (!formData?.postTo || formData.postTo.length === 0) {
      toast.error("Please select Post To (Player or Club)");
      return false;
    }

    // Live booking (boolean)
    if (
      formData?.eventLiveBooking === undefined ||
      formData?.eventLiveBooking === null
    ) {
      toast.error("Please select live booking availability");
      return false;
    }

    return true;
  };

  const handleSuccess = (status) => {
    if (status) {
      if (formData?.id) {
        navigate("/my-posting");
      } else {
        navigate("/dashboard");
      }
    }
    setLoader(false);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateEventFields()) return;
    setLoader(true);
    const request = {
      ...formData,
      type: "event",
      eventId: null,
      feeRange: null,
      countryName: formData?.countryName ?? "India",
      startDateTimeUtc: convertDateTimeUtc(
        formData?.startDate,
        formData?.startTime,
      ),
    };
    if (formData?.id) {
      const updateRequest = { ...request, eventId: formData?.id };
      dispatch(updateEvent(updateRequest, handleSuccess));
    } else {
      dispatch(createEvent(request, handleSuccess));
    }
  };

  const POST_TO = [
    { label: "Player", value: "player" },
    { label: "Club", value: "club" },
  ];

  return (
    <div className="pt-2">
      <h1 className="lg:max-w-5xl w-[95%] flex items-center gap-3 mt-10 pb-3 mx-auto text-2xl text-black ">
        <MdOutlineArrowBackIosNew
          onClick={() => navigate(-1)}
          className="h-6 w-6 cursor-pointer hover:text-highlight"
        />{" "}
        {formData?.id ? "Update" : "Create"} Event
      </h1>
      <form
        onSubmit={handleSubmit}
        className="lg:max-w-5xl w-[95%] mx-auto my-2 bg-white p-6 rounded-xl shadow-3xl border border-gray-200"
      >
        {loader && <FullPageLoader />}

        <UserNameHeader />

        <div className="grid md:grid-cols-2 grid-cols-1 gap-4 mb-6 mt-4">
          <SelectField
            id="age-select"
            label="Age group playing"
            placeholder="Age Group Playing"
            name="age"
            options={ageGroup}
            onChange={(value) => handleChange("ageGroup", value)}
            value={formData?.ageGroup}
          />

          <SelectField
            id="gender-select"
            label="Gender"
            placeholder="Gender"
            isRequired={true}
            name="gender"
            options={EVENT_GENDERS}
            onChange={(value) => handleChange("gender", value)}
            value={formData?.gender}
          />

          <SelectField
            label="Select game or sport"
            isSport
            placeholder="Select game or sport"
            onChange={(value) => handleChange("category", value)}
            options={configData?.gamesDetails}
            value={formData?.category}
            isRequired={true}
          />

          <div className="">
            <label className="block text-sm md:font-semibold font-medium text-gray-700 mb-1">
              Post To
              <span className="text-red-500 ml-1 font-bold">*</span>
            </label>
            <div className="flex md:flex-row flex-col gap-3">
              {POST_TO?.map((item) => {
                return (
                  <label className="flex-1 relative cursor-pointer">
                    <input
                      type="radio"
                      onClick={() => {
                        let temp = [...formData?.postTo];
                        if (temp.includes(item?.value)) {
                          temp = temp.filter((post) => post != item?.value);
                        } else {
                          temp.push(item?.value);
                        }

                        setFormData((formData) => ({
                          ...formData,
                          postTo: temp,
                        }));
                      }}
                      className="peer sr-only"
                      checked={formData?.postTo?.includes(item.value)}
                    />
                    <p className="md:px-4 px-2 py-3 md:text-md text-sm border-2 border-gray-300 rounded-lg text-center peer-checked:border-[#2bace2] peer-checked:bg-[#2bace2]/5 peer-checked:text-[#2bace2] transition-all font-medium">
                      {item?.label}
                    </p>
                  </label>
                );
              })}
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 grid-cols-1 gap-6 mb-4">
          <DateAndTimePicker
            dateLabel="Select Date"
            showDate
            showTime={false}
            selectedDate={formData?.startDate}
            onDateChange={(date) =>
              handleChange(
                "startDate",
                date ? moment(date).format("YYYY-MM-DD") : "",
              )
            }
            placeholderDate="Start Date"
            isRequired
            inputClassName="w-full"
          />
          <Input
            type="time"
            label={"Time"}
            isRequired
            value={formData?.startTime}
            onChange={(time) => handleChange("startTime", time)}
          />
        </div>

        <div className="grid md:grid-cols-2 grid-cols-1 gap-6 mb-4">
          <Input
            label="Capacity"
            isRequired={true}
            name="capacity"
            type="number"
            value={formData?.capacity}
            onChange={(e) => handleChange("capacity", e * 1)}
            placeholder="Enter capacity"
          />

          <LocationPicker
            label="Location"
            isRequired
            onChange={(place) => {
              console.log("place", place);
              const countryObj = place?.address_components?.find((item) =>
                item.types.includes("country"),
              );
              handleChange(
                "countryName",
                countryObj ? countryObj.long_name : "India",
              );
              handleChange("address", place?.formatted_address);
              handleChange("coordinates", [
                place?.geometry?.location?.lng(),
                place?.geometry?.location?.lat(),
              ]);
            }}
            value={formData?.address}
            placeholder="Search by address"
          />
        </div>

        <div className="grid md:grid-cols-2 grid-cols-1 gap-6 mb-4">
          <Textarea
            id="requirements"
            label="Requirements"
            value={formData?.requirements}
            onChange={(e) => handleChange("requirements", e.target.value)}
            placeholder="Requirements"
            rows={4}
          />
          <Textarea
            id="description"
            label="Description"
            value={formData?.description}
            onChange={(e) => handleChange("description", e.target.value)}
            placeholder="Enter description"
            rows={4}
          />
        </div>

        <div className="grid md:grid-cols-2 grid-cols-1 gap-6 mb-4">
          <Input
            label="Fee"
            isRequired={true}
            name="capacity"
            type="number"
            value={formData?.eventFees}
            onChange={(e) => handleChange("eventFees", e)}
            placeholder="Enter fee"
          />
          <PhoneNumber
            label="Contact number"
            placeholder="Phone number"
            onChange={(val) =>
              setFormData((formData) => ({
                ...formData,
                phone: val?.countryCode + val?.phoneNumber,
              }))
            }
            phone={formData?.phone}
          />
        </div>
        <div className="p-4 border border-gray-200 rounded-lg bg-gray-50">
          <RadioButton
            label="Live booking availability"
            isRequired={true}
            isBoolean
            options={[
              {
                id: true,
                label: "Yes",
              },
              {
                id: false,
                label: "No",
              },
            ]}
            selected={formData?.eventLiveBooking}
            onChange={(e) => {
              handleChange("eventLiveBooking", stringToBoolean(e.target.value));
            }}
          />
        </div>

        <div className="flex items-center justify-center mt-10">
          <Button
            variant="primary"
            size="md"
            className="lg:w-1/3 w-full shadow-lg transition duration-200"
          >
            {formData?.id ? "Update" : "Create"} Event Card
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CreateEventCard;
